import $ from 'jquery';
import 'jquery-sticky';
import BrowserDetect from '../utils/BrowserDetect';
import initEditionPicker from './commons/NavbarEditionPicker';
import initScroll from './commons/NavbarScroll';
import initSearch from './commons/NavbarSearch';
import initUserMenu from './commons/NavbarUserMenu';
import initSleekBar from './desktop/NavbarSleekBar';
import initNavbarTracking from './desktop/NavbarTracking';
import initMobileMenu from './mobile/NavbarMenu';
import initSwitcher from './mobile/NavbarSwitcher';

function initNavbar(isStatic) {
    $(function() {

        let desktopMenuSelector = $("#menu");

        if(BrowserDetect.isIe9orBelow()) {
            desktopMenuSelector.addClass("menu--ie");
        } else if(!isStatic) {
            initScroll();
        }
        if(BrowserDetect.isSafari())
            desktopMenuSelector.addClass("menu--no-animate");
        initEditionPicker();
        initSearch();
        initUserMenu();
        initSleekBar();
        initMobileMenu();
        initSwitcher("data-switcher-rubric", $("#mobile-menu-rubric .category-switcher__button"), $("#mobile-menu-rubric .categories"));
        initSwitcher("data-switcher-spectacle", $("#mobile-menu-spectacle .category-switcher__button"), $("#mobile-menu-spectacle .categories"));
        initNavbarTracking();

        // check to call the function only on desktop
        if(desktopMenuSelector[0].offsetWidth) window.Analytics.sendLoadTime('desktopMenuReady');
    });
}

window.initNavbar = initNavbar;



// WEBPACK FOOTER //
// ./js/navbar/Navbar.js